export default function extractTokenExpirationDate(token: string): Date {
  return new Date(JSON.parse(atob(token.split(".")[1])).exp * 1000);
}
